import React from 'react';
import './PasswordModalInfoMatch.scss';
import Modal from "../Modal/Modal";
import {useTranslation} from "react-i18next";

const PasswordModalInfoMatch = ({show, onClose}) => {
  const {t} = useTranslation();
  const handlerOnClose = () => {
    onClose()
  }
  return (
    <div className="PasswordModalInfoMatch" data-testid="PasswordModalInfoMatch">
      <Modal
        show={show}
        onClose={handlerOnClose}
        content={
          <>
            <div className={"content-description-password paragraph-main-fs8"}>
              <div className="title-description">
                <p className="desc-title">{t('password.info.title')}</p>
              </div>
              <div className="pass-desc">
                <div className="inner-desc">
                  <ul>
                    <li>{t('password.info.point1')}</li>
                    <li>{t('password.info.point7')}</li>
                    <li>{t('password.info.point8')}</li>
                    <li>{t('password.info.point9')}</li>
                  </ul>
                </div>
                <div className="title-description">
                  <p className="desc-title">{t('password.info.point2')}</p>
                </div>
                <div className="inner-desc">
                  <ul>
                    <li>{t('password.info.point3')}</li>
                    <li>{t('password.info.point4')}</li>
                    <li>{t('password.info.point5')}</li>
                    <li>{t('password.info.point6')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </>
        }
        type={"button"}
        linkTitle={t("common.hoCapito")}
        onFirstClick={handlerOnClose}
      />
    </div>
  )
};

export default PasswordModalInfoMatch;
